import React, { useEffect, useState } from 'react';
import { useTranslation } from '../i18n/LanguageProvider';
import {
  applyStoredConsent,
  getStoredConsent,
  loadGoogleAnalytics,
  storeConsent,
  denyAnalyticsConsent,
} from '../utils/analytics';

const CookieConsent: React.FC = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = getStoredConsent();
    if (stored) {
      applyStoredConsent();
    } else {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    storeConsent('accepted');
    loadGoogleAnalytics();
    setVisible(false);
  };

  const handleDecline = () => {
    storeConsent('declined');
    denyAnalyticsConsent();
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div
      role="dialog"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-message"
      className="fixed bottom-0 inset-x-0 z-[100] p-4 md:p-6"
    >
      <div className="max-w-4xl mx-auto bg-navy text-sand rounded-2xl shadow-2xl border border-sand/10 p-6 md:p-8">
        <h2 id="cookie-consent-title" className="text-lg font-bold font-space mb-2">
          {t('cookieConsent.title')}
        </h2>
        <p id="cookie-consent-message" className="text-sand/80 text-sm md:text-base leading-relaxed mb-6">
          {t('cookieConsent.message')}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:justify-end">
          <button
            type="button"
            onClick={handleDecline}
            className="px-6 py-3 rounded-lg border border-sand/30 text-sand hover:bg-sand/10 transition-colors font-medium"
          >
            {t('cookieConsent.decline')}
          </button>
          <button
            type="button"
            onClick={handleAccept}
            className="px-6 py-3 rounded-lg bg-sky text-navy hover:bg-sky/90 transition-colors font-semibold"
          >
            {t('cookieConsent.accept')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
